export const DEFAULT_VOICE_LANGUAGE = 'English';
export const DEFAULT_VOICE_ACCENT = 'american';
